import React from 'react';
import PropTypes from 'prop-types';

import RsTableHeaderSortControl from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderSortControl';
import { mapSortStringToObject } from '@Pages/RetroSynthesis/utils';
import HoverTooltip from '@Components/HoverTooltip';
import noop from 'lodash/noop';
import { ButtonWithIcon } from '@els/els-react--button';

import './ExamplesTableHeader.custom.scss';

function ExamplesTableHeader({ sortList, setSortList = () => {} }) {
  const onSortChange = ({ sort } = {}) => {
    // eslint-disable-next-line no-unused-expressions
    sort && setSortList([mapSortStringToObject(sort)]);
  };

  return (
    <tr className="c-els-table__row c-els-table__row--head examples-table-header">
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        <div className="examples-table-header__item number">
          <RsTableHeaderSortControl sortList={sortList} sortParam="exampleNo" onChange={onSortChange}>
            Number
          </RsTableHeaderSortControl>
        </div>
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        <div className="examples-table-header__item">
          <HoverTooltip id="tooltip-building-blocks" tooltip="Published reactions from patents and journals" theme="simple" trigger="click">
            <ButtonWithIcon
              className="u-els-margin-right-1o2"
              sprite="InformationOutlineCircle"
              iconOnly
              type="link"
              linkIconSize="xs"
              onClick={noop}>
              Reaxys Examples information
            </ButtonWithIcon>
          </HoverTooltip>
          Reaxys Examples
        </div>
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header c-els-table__cell--sort">
        <div className="examples-table-header__item">
          <HoverTooltip
            id="tooltip-building-blocks"
            width="20rem"
            tooltip="Similarity score of published reaction that informed the predicted reaction based on their extended reaction centre (the atoms and bonds directly involved in the reaction and their immediate neighbourhood)"
            theme="simple"
            trigger="click">
            <ButtonWithIcon
              className="u-els-margin-right-1o2"
              sprite="InformationOutlineCircle"
              iconOnly
              type="link"
              linkIconSize="xs"
              onClick={noop}>
              Score information
            </ButtonWithIcon>
          </HoverTooltip>
          <RsTableHeaderSortControl sortList={sortList} sortParam="score" onChange={onSortChange}>
            Score
          </RsTableHeaderSortControl>
        </div>
      </th>
    </tr>
  );
}

ExamplesTableHeader.propTypes = {
  sortList: PropTypes.array,
  setSortList: PropTypes.func,
};

export default ExamplesTableHeader;
